var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlidersFilled = function SvgSlidersFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.356 16.63a3.73 3.73 0 0 1 4.575 2.62h12.068a1 1 0 1 1 0 1.998H10.931a3.728 3.728 0 0 1-7.194 0H1.001a1 1 0 0 1 0-1.999h2.736a3.73 3.73 0 0 1 2.62-2.62M15.69 8.38A3.727 3.727 0 0 1 20.263 11h2.736a1 1 0 0 1 0 2h-2.736a3.726 3.726 0 0 1-7.193 0H1.001a1 1 0 1 1 0-2h12.07a3.73 3.73 0 0 1 2.62-2.62M6.356.131a3.73 3.73 0 0 1 4.575 2.62h12.068a1 1 0 1 1 0 2H10.931a3.728 3.728 0 0 1-7.194 0H1.001a1 1 0 0 1 0-2h2.736a3.73 3.73 0 0 1 2.62-2.62"
  })));
};
export default SvgSlidersFilled;